/** 输入框类型 */
export const enum INPUT_TYPE {
  /** 账号 */
  ACCOUNT = '0',
  /** 手机号 */
  PHONE = '1',
  /** 邮箱 */
  EMAIL = '2',
  /** 获取短信验证码 */
  GET_SMS_CODE = '3',
  /** 获取邮箱验证码 */
  GET_EMAIL_CODE = '4',
  /** 密码 */
  PASSWORD = '5',
  /** 再一次输入密码 */
  AGAIN_PASSWORD = '6',
  /** 图形验证码 */
  IMG_VERIFY = '7',
  /**输入手机号或者邮箱 */
  PHONE_OR_EMAIL = '8',
  /**输入手机号或者邮箱的验证码 */
  PHONE_OR_EMAIL_CODE = '9',
}

/** 登陆类型 */
export const enum LOGIN_TYPE {
  ACCOUNT = 1,
  EMAIL = 2,
  PHONE = 3
}

/** 输入框图标 */
export const INPUT_ICON = new Proxy({}, {
  get(_, key) {
    switch (key as unknown as INPUT_TYPE) {
      case INPUT_TYPE.ACCOUNT:
        return 'LiveCloud-common-yonghuming1'
      case INPUT_TYPE.PHONE:
      case INPUT_TYPE.PHONE_OR_EMAIL:
        return 'LiveCloud-common-shouji'
      case INPUT_TYPE.EMAIL:
        return 'LiveCloud-common-weidu'
      case INPUT_TYPE.GET_SMS_CODE:
      case INPUT_TYPE.GET_EMAIL_CODE:
      case INPUT_TYPE.IMG_VERIFY:
      case INPUT_TYPE.PHONE_OR_EMAIL_CODE:
        return 'LiveCloud-common-yanzhengma1'
      case INPUT_TYPE.PASSWORD:
      case INPUT_TYPE.AGAIN_PASSWORD:
        return 'LiveCloud-common-mima1'
      default:
        return ''
    }
  }
})

